import React, { useState, useEffect, useRef } from 'react';
import styles from './FormError.scss';

export interface IFormError {
    text: string;
}

const FormError: React.FC<React.PropsWithChildren<IFormError>> = ({ text = null }) => {
    return <>{text !== null && <p className={styles.formError + ' ' + (text === '' ? styles.empty : '')}>{text || '\u00A0'}</p>}</>;
};

export default FormError;
